<div *ngIf="hasData; else noData" class="chart-box">

  <div class="chart">
    <canvas baseChart [data]="pieChartData" [options]="pieChartOptions" type="pie" data-cy="bankPieChart" [height]="isMobile ? 200 : 270" [width]="isMobile ? 200 : 270"></canvas>
  </div>

  <div>
    <div class="data">
      <label *ngFor="let label of labels" class="data-line">
        <span class="data-line__color" [style.background]="label.color"></span>
        <span class="data-line__name"> {{ label.name }}</span>
        <span class="data-line__count"> {{ label.count }} </span>
      </label>
    </div>
  </div>
</div>

<ng-template #noData>
  <span data-cy="bankPieChartNoDataToShow"> Não existem dados com os critérios de seleção informados. </span>
</ng-template>
